import { EMPTY_FIELD } from 'constants/emptyField';

import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import { useTheme } from '@mui/material/styles';
import { useUserMerchantAccessPermission } from 'pages/Users/hooks/useUserMerchantAccessPermission';
import { ArrayField, useRecordContext } from 'react-admin';
import { Stack } from 'shared/mui/Stack/Stack';
import { ChipField, SingleFieldList } from 'shared/react-admin/Fields';
import { User } from 'types/embedded/user';

type Props = {
  label?: string;
  source?: string;
  sortable?: boolean;
};

export const UsersMerchantAccessField: React.FC<Props> = ({ label }) => {
  const record = useRecordContext<User>();
  const theme = useTheme();
  const isUserMerchantAccessAvailable = useUserMerchantAccessPermission(record?.rolesValues);

  if (!isUserMerchantAccessAvailable) {
    return (
      <Stack>
        <DoNotDisturbAltIcon htmlColor={theme.palette.error.light} sx={{ width: '20px' }} />
      </Stack>
    );
  }

  return (
    <ArrayField label={label} sortable={false} source="merchantAccesses">
      <SingleFieldList linkType={false}>
        <ChipField emptyText={EMPTY_FIELD} size="small" source="merchant.name" />
      </SingleFieldList>
    </ArrayField>
  );
};
